import { AnalyticsEvent } from "@omni/types/components/tracking/analyticsEvent";
import { EventType } from "@omni/types/components/tracking/eventType.enum";
import { AvailableInStoreTrackingInfo } from "@omni/types/components/tracking/tracking-info/feature/availableInStore.trackingInfo";

import * as TrackingService from "../../tracking.service";

export const track = (trackingInfo: AvailableInStoreTrackingInfo) => {
    const event: AnalyticsEvent<AvailableInStoreTrackingInfo> = {
        event: EventType.AvailableInStore,
        payload: {
            eventData: trackingInfo
        }
    };

    TrackingService.track(event);
};

export const trackOn = (storeId?: string) => {
    track({
        on: true,
        name: "Toggle voorkeurswinkel aan",
        storeId: storeId
    });
};

export const trackOff = (storeId?: string) => {
    track({
        on: false,
        name: "Toggle voorkeurswinkel uit",
        storeId: storeId
    });
};
